export default  {
    component: 'plant_subscription',
    name: 'plant_subscription',
    fields: [
      {
        param: 'plant_id',
        type: 'number',
        required: true,
        identifier: true,
        hidden: true
      },
      {
        name: 'Components',
        param: 'components',
        type: 'text',
        description: `This table is configured in order to add plant to user. Dashboard should be added in comma seperated format.
        - e.g. [homepage,inverter-dash,analytics-dash,alert-dash,mfm-dash,calculated-analytics-dash,live-dash] configure which is required.
        > Options are provided below:
        - homepage (mandatory)
        - sld
        - inverter-dash
        - ws-dash
        - scb-dash,scb-channel
        - mfm-dash
        - analytics-dash
        - calculated-analytics-dash
        - other-sensors-dash
        - alert-dash
        - live-dash
        - admin-control
        - pr-dash
        - fronius
        - zone-monitoring (old)`
      }
    ]
  }